// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__9USXg","title":"styles_title__kmnIR","inputs_wrapper":"styles_inputs_wrapper__ymLur","input_wrapper":"styles_input_wrapper__Ror2i"};